import { render } from "./PostMeetingComponent.vue?vue&type=template&id=8ca74a5e"
import script from "./PostMeetingComponent.vue?vue&type=script&lang=js"
export * from "./PostMeetingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__